import { MEDIA } from "@/lib/content";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF007F]">
              In the gym
            </div>
            <h2 className="font-display uppercase tracking-tight text-5xl md:text-6xl mt-3 leading-[0.9]">
              Camden in <span className="text-[#00E5FF]">motion.</span>
            </h2>
          </div>
        </div>

        {/* Tetris-style asymmetric grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          <div className="md:col-span-8 md:row-span-2 group relative overflow-hidden bg-[#18181B] aspect-[4/5] md:aspect-auto md:min-h-[640px]">
            <img
              src={MEDIA.gallery1}
              alt="Camden in action — layup"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF]">#10</div>
              <div className="font-display text-3xl">Rise &amp; finish</div>
            </div>
          </div>

          <div className="md:col-span-4 group relative overflow-hidden bg-[#18181B] aspect-square">
            <img
              src={MEDIA.gallery2}
              alt="Camden — fast break"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
              <div className="font-display text-xl">Fast break</div>
            </div>
          </div>

          <div className="md:col-span-4 group relative overflow-hidden bg-[#18181B] aspect-square">
            <img
              src={MEDIA.hero}
              alt="Camden — running upcourt"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
              <div className="font-display text-xl">Court vision</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
